import React, { useContext, useState, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { useParams } from 'react-router-dom';
import { nanoid } from 'nanoid';
import AsyncLocalStorage from '../../utils/AsyncLocalStorage';
import { useNavigate } from 'react-router-dom';
import DeliveryController from '../../controller/DeliveryController';
import toast from 'react-hot-toast';
import { DELIVERY_POINTS, DELIVERY_WITHDRAW_MIN } from '../../utils/DataType';

const DeliveryManAccumulate = (oProps: any) => {
  const [sUUid, set_sUUid] = useState<string>("");
  const [iCurrentPoints, set_iCurrentPoints] = useState<number>(0);
  const [iRemainingOrderCnt, set_iRemainingOrderCnt] = useState<number>(200);
  const navigate = useNavigate();
  let oParams = useParams();

  const GlobalStyle = createGlobalStyle`
    html, body, #root, #root > div {
      height: 100%
    }
  `
  const getPoints = async (sUUidValue: string) => {
    try {
      const response = await DeliveryController.getDeliveryPoint(sUUidValue);

      if (response.data.ok) {
        if (response.data.data) {
          set_iCurrentPoints(response.data.data.point);
          let iRemainCalc = Math.round((DELIVERY_WITHDRAW_MIN - response.data.data.point) / DELIVERY_POINTS);
          set_iRemainingOrderCnt(iRemainCalc);
          if (iRemainCalc <= 0) {
            let sOrderId = oParams.order_id;
            let sOrderSeq = oParams.order_seq;
            navigate(`/order/register/${sOrderId}/${sOrderSeq}`);
          }
        }
      }
    } catch (err) {
      console.log('err-->', err);
    }
  }

  const initUuid = async () => {
    let sUuid = await AsyncLocalStorage.getItem('uuid');
    if (sUuid) {
      set_sUUid(sUuid);
    } else {
      let sNewUuid = nanoid();
      await AsyncLocalStorage.setItem('uuid', sNewUuid);
      set_sUUid(sNewUuid);
    }
  }

  useEffect(() => {
    initUuid();

    return () => {
    };
  }, []);

  useEffect(() => {
    if (sUUid) {
      getPoints(sUUid);
    }

    return () => {
    };
  }, [sUUid]);

  return (
    <Style>
      <>
        <GlobalStyle />
        <div className="content">
          <img src={`${process.env.PUBLIC_URL}/img/knock_logo.png`} width="14%" alt="logo" />
          <>
            <div className="textContent">
              <h1>{DELIVERY_POINTS}포인트가{'\n'}적립되었어요{'\n'}안전운전 하세요!😄</h1>
            </div>
            <div className="spacer"></div>
            <h3>
              {`현재 보유하신 응원지원금은\n`}
              <span className={`pickupFont pointFont`}>{`${iCurrentPoints.toLocaleString()}P`}</span>{` 입니다`}
            </h3>
            <div className="footer">
              <div className="box">
                <h4>- {DELIVERY_WITHDRAW_MIN.toLocaleString()}원 이상부터 현금으로 출금 가능해요 💸</h4>
                <h4>- 배달 1건당 {DELIVERY_POINTS}포인트씩 쌓여요 💰</h4>
              </div>
              <button className={`deliveryRemaining`} onClick={() => console.log('')}>
                <h3>포인트 정산까지{'\n'}배달이 {iRemainingOrderCnt}건 남았어요</h3>
              </button>
            </div>
          </>

        </div>
      </>
    </Style >
  );
};
export default DeliveryManAccumulate;

export const Style = styled.div`
  .pickupFont {
    color: #4dd2ae;
  }
  .deliveryFont {
    color: #ff8d23;
  }
  .pointFont {
    font-size: 32px; font-weight: 700;
  }

  .content {
    position: relative;
    /*width: 100%;*/
    height: 100%;
    text-align: left;
    padding: 10px;
    background: #ffffff;
    white-space: pre-line;
    display: flex;
    flex-direction: column;
    flex:1;
  }
  .textContent {
  }
  img {
    padding-bottom:30px;
  }
  p {
    font-size: 14px;
    line-height: 14px;
    font-weight: 300;
    color: #000000;
    margin: 0;
  }
  h1 {
    font-size: 28px;
    line-height: 40px;
    color: #555555;
    font-family: 'Nunito Sans', 'Helvetica Neue', sans-serif;
    font-weight: 600;
    margin-bottom: 20px;
  }
  h3 {
    line-height: 30px;
    color: #555555;
    font-family: 'Nunito Sans', 'Helvetica Neue', sans-serif;
    margin: 0;
    font-weight: 500;
    span.delivery {
      background: #ffdcbb;
    }
    span.pickup {
      background: #d3f7ed;
    }
    span.point {
      font-size: 32px;
      line-height: 36px;
      background: none;
      font-weight: 700;
    }
  }
  .spacer {
    flex:1
  }
  .gap {
    margin-top: 6%;
  }
  .footer {
    padding-top: 10px;
  }
  .box {
    background: #f6f6f6;
    border-radius: 10px;
    padding: 16px;
  }
  .box h4 {
    font-size: 16px;
    line-height: 30px;
    color: #979797;
    font-weight: 500;
    margin: 0;
  }
  button {
    margin-top: 12px;
    width: 100%;
    height: 14vh;
    background: #ff8d23;
    border: none;
    border-radius: 5px;
    min-height: 120px;
  }
  button.deliveryRemaining {
    background: #CECECE;
    h3 {
      font-weight: 600;
    }
  }
  button.delivery {
    background: #ff8d23;
  }
  button h1 {
    font-weight: 600;
    margin: 0;
    color: #ffffff;
  }
  button h3 {
    font-weight: 500;
    color: #ffffff;
  }
`;
